import { useEffect, useRef } from 'react';

const STALL_TIMEOUT_MS = 90_000;

/**
 * Detects stalled streams — if streaming but no new content for 90s, auto-stops.
 */
export default function useStreamStallDetection(isStreaming, messagesLength, stopChat, onStall) {
  const streamTimeoutRef = useRef(null);
  const lastMessageCountRef = useRef(0);

  useEffect(() => {
    if (!isStreaming) {
      if (streamTimeoutRef.current) { clearTimeout(streamTimeoutRef.current); streamTimeoutRef.current = null; }
      lastMessageCountRef.current = messagesLength;
      return;
    }

    if (messagesLength !== lastMessageCountRef.current) {
      lastMessageCountRef.current = messagesLength;
      if (streamTimeoutRef.current) clearTimeout(streamTimeoutRef.current);
    }

    streamTimeoutRef.current = setTimeout(() => {
      if (isStreaming) {
        console.warn('[Chat] Stream stalled for 90s, stopping');
        stopChat();
        onStall?.('The AI took too long to respond. Please try again.');
      }
    }, STALL_TIMEOUT_MS);

    return () => {
      if (streamTimeoutRef.current) { clearTimeout(streamTimeoutRef.current); streamTimeoutRef.current = null; }
    };
  }, [isStreaming, messagesLength, stopChat, onStall]);
}
